import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.habitType;

const getHabitType = createSelector(getData, habitType => values(habitType));

export default getHabitType;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getHabitType.js